import styled from 'styled-components';

const ContentsContainer = styled.div``;

export { ContentsContainer };
